module.exports = __webpack_public_path__ + "img/ms-header-arrow.604fe34d.svg";